(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileOrTouch = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const lowPower = Boolean(connection?.saveData) || (navigator.deviceMemory && navigator.deviceMemory <= 4);
  const designMode = document.documentElement.classList.contains('shopify-design-mode') || Boolean(window.Shopify?.designMode);
  const canAnimate = () => !designMode && !reducedMotion.matches && !mobileOrTouch.matches;

  function addAtmosphere() {
    if (!canAnimate() || document.querySelector('.zk-atmosphere')) return;

    document.body.classList.add('zk-atmosphere-enabled');

    const atmosphere = document.createElement('div');
    atmosphere.className = 'zk-atmosphere';
    atmosphere.setAttribute('aria-hidden', 'true');
    atmosphere.innerHTML = '<div class="zk-atmosphere__petals"></div>';
    document.body.prepend(atmosphere);

    const petals = atmosphere.querySelector('.zk-atmosphere__petals');
    let petalTimer;

    function createPetal() {
      const petalLimit = lowPower ? 3 : 6;
      if (!canAnimate() || document.hidden || petals.childElementCount >= petalLimit) return;
      const petal = document.createElement('i');
      petal.className = 'zk-petal';
      petal.style.setProperty('--x', `${8 + Math.random() * 84}vw`);
      petal.style.setProperty('--drift', `${-90 + Math.random() * 180}px`);
      petal.style.setProperty('--duration', `${lowPower ? 11 : 8 + Math.random() * 4}s`);
      petal.style.setProperty('--delay', `${Math.random() * 0.7}s`);
      petal.style.setProperty('--scale', `${0.65 + Math.random() * 0.8}`);
      petals.appendChild(petal);
      petal.addEventListener('animationend', () => petal.remove(), { once: true });
    }

    function schedulePetals() {
      window.clearInterval(petalTimer);
      if (canAnimate() && !document.hidden) {
        createPetal();
        petalTimer = window.setInterval(createPetal, lowPower ? 3200 : 1900);
      }
    }

    reducedMotion.addEventListener?.('change', schedulePetals);
    mobileOrTouch.addEventListener?.('change', schedulePetals);
    document.addEventListener('visibilitychange', schedulePetals, { passive: true });
    schedulePetals();

  }

  function addSectionReveals() {
    if (!('IntersectionObserver' in window) || !canAnimate()) return;
    const sections = document.querySelectorAll('#MainContent > .shopify-section, footer > .shopify-section');
    sections.forEach((section, index) => {
      if (index === 0 || section.classList.contains('zenkai-header')) return;
      section.classList.add('zk-reveal');
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('zk-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    document.querySelectorAll('.zk-reveal').forEach((section) => observer.observe(section));
  }

  function addClickSeals() {
    document.addEventListener('click', (event) => {
      if (!canAnimate()) return;
      const target = event.target.closest('a, button, summary, [role="button"]');
      if (!target || target.closest('.zk-mobile-nav')?.hasAttribute('hidden')) return;
      const seal = document.createElement('span');
      seal.className = 'zk-seal';
      seal.style.left = `${event.clientX}px`;
      seal.style.top = `${event.clientY}px`;
      seal.innerHTML = '<i></i><b></b><em></em><strong></strong>';
      document.body.appendChild(seal);
      seal.addEventListener('animationend', () => seal.remove(), { once: true });
    });
  }

  function init() {
    addAtmosphere();
    addSectionReveals();
    addClickSeals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
